import type { ReactNode } from 'react'
import { Icon } from '@/components/Icon'
import { Link } from 'react-router'
import styles from './NotificationsSidebarMenu.module.css'
import { links } from '@/utils/link'

export interface NotificationsSidebarMenuProps {
  onClose: () => unknown
}

export function NotificationsSidebarMenu({
  onClose,
}: NotificationsSidebarMenuProps) {
  return (
    <div className={styles.root} data-test="Menu">
      <div className={styles.sideActions}>
        <SideAction title="Close">
          <Icon name="back" onClick={onClose} />
        </SideAction>
      </div>
      <div className={styles.divider} />
      <div className={styles.sideActions}>
        <SideAction
          title="Notification Preferences"
          to={links.profileNotifications()}
          onPress={onClose}
          testId="Prefs"
        >
          <Icon name="settings" />
        </SideAction>
      </div>
    </div>
  )
}

interface SideActionProps {
  children: ReactNode
  to?: string
  title?: string
  onPress?: () => unknown
  testId?: string
}

function SideAction({ children, to, onPress, title, testId }: SideActionProps) {
  return (
    <Link
      to={to || '#'}
      className={styles.sideAction}
      onClick={onPress}
      title={title}
      data-test={testId}
    >
      {children}
    </Link>
  )
}
